import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as TableUI from '../../../../../components/Table/Table'
import { TextInputV2 } from 'src/components'
import { isNullOrUndefined } from 'util'

type RowFilterProp = {
    applyFilter: (p1: Record<string, any>) => void,
}

const RowFilter: React.FC<RowFilterProp> = ({
    applyFilter
}) => {
    const {t} = useTranslation()

    const [filter, setFilter] = useState({
        material: null,
        plant: null,
        sloc: null,
        uu: null,
        sap: null,
        outstanding: null,
        remaining: null
    })

    const handleChange = (fil : Record<string, any>) => {
        const newFilter = {
            ...filter,
            ...fil
        }
        setFilter(newFilter)
        applyFilter(newFilter)
    }

    return (
        <>
        <TableUI.TRowFilter>
            <td>
                <div></div>
            </td>
            <td>
                <TextInputV2
                    type='text'
                    placeholder={t('sub-order-produk')}
                    onChange={(e: any) => handleChange({material: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='text'
                    placeholder={t('sub-order-gudang')}
                    onChange={(e: any) => handleChange({plant: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='text'
                    placeholder={t('storage location')}
                    onChange={(e: any) => handleChange({sloc: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('uu-stock')}
                    onChange={(e: any) => handleChange({uu: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('sap-stock')}
                    onChange={(e: any) => handleChange({sap: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('outstanding-stock')}
                    onChange={(e: any) => handleChange({outstanding: e.target.value})}
                    />
            </td>
            <td>
                <TextInputV2
                    type='number'
                    placeholder={t('remaining-stock')}
                    onChange={(e: any) => handleChange({remaining: e.target.value})}
                    />
            </td>
      </TableUI.TRowFilter>
        </>
    )
}

export {RowFilter}
